import { render, staticRenderFns } from "./ConversionSignificance.vue?vue&type=template&id=106801c8&"
import script from "./ConversionSignificance.vue?vue&type=script&lang=js&"
export * from "./ConversionSignificance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports